import styled from 'styled-components';

export const LogoBox = styled.div`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export default LogoBox;
